//admin utility
import { HttpClient, HttpParams } from '@angular/common/http';
declare var $;
import { AfterViewInit, Component, OnInit, ViewChild ,ElementRef} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { ResidentialService } from 'src/app/questionarie-signup/questionnaire-residential/residential.service';
import { MatTable } from '@angular/material/table';
import { _ } from 'underscore';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import {IMyDpOptions, IMyDate} from 'mydatepicker';
import { Clipboard } from '@angular/cdk/clipboard';

import {
  
  AsyncValidatorFn,
  
} from '@angular/forms';
import { map } from 'rxjs/operators';

import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { EnergyProvidersModalComponent } from '../../admin-utility/energy-providers-modal/energy-providers-modal.component';
import { SnackbarComponent } from '../../snackbar/snackbar.component';
import {
  
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';

// import { AdminUtilityReportComponent } from '../admin-utility/admin-utility-report/admin-utility-report.component'
import { ItemsList } from '@ng-select/ng-select/ng-select/items-list';
import { environment } from '../../../environments/environment';
import * as moment from 'moment-timezone';
import { DatePipe } from '@angular/common';
import { Block } from '../../shared/models/block';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators, FormControlName, AbstractControl,ValidatorFn,ValidationErrors
} from '@angular/forms';
import { Observable, fromEvent, merge } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import {NgbModal, NgbActiveModal, NgbModule, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';


/**
 * @title Table with pagination
 */
@Component({
  selector: 'app-admin-promocode',
  templateUrl: './admin-promocode.component.html',
  styleUrls: ['./admin-promocode.component.css'],
  providers: [DatePipe],

  entryComponents: [SnackbarComponent],
})
export class AdminPromoCodeComponent implements OnInit {
  displayTooltip = true;


  copyText() {
    this.clipboard.copy(this.managerMaintenanceForm.get('AffiliateLink').value);

    setTimeout(function(){
      $('[data-toggle="tooltip"], .tooltip').tooltip("hide");
    },1000)
  }
  ngbModalOptions: NgbModalOptions = {
    backdrop : 'static',
    keyboard : false
  };
  public myDatePickerOptions: IMyDpOptions;
  modalRef: BsModalRef;
  msg;
  title;
  @ViewChild('SuccessModel', { static: true }) SuccessModel: ElementRef;
  // Use with the generic validation message class
  PromoCodeId;
  pageheadername;
  minDate= new Date();
  maxDate= new Date();
  managerMaintenanceForm: FormGroup;
  AffiliateList= [];
  AffiliateLink;
  ShowAffilateField = false
  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private router: Router,
    private residentialService: ResidentialService,
    public dialog: MatDialog,
    private snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private modalService: BsModalService,
    private clipboard: Clipboard
  ) {

    this.managerMaintenanceForm = this.fb.group({
     // PromoCode: [, Validators.required, this.uniquePromoValidator()],
      PromoCode: [null, [Validators.required,//this.uniquePromoValidator() //UsernameValidator.createValidator(residentialService)
      ]],
      PromoCodeDescription: [, Validators.required],
      StartDate: new FormControl('', Validators.required),
      EndDate: new FormControl('', Validators.required),
      Affiliate: [],
      // PromoCode: new FormControl('', Validators.compose([
      //   Validators.required,
      //   Validators.pattern('((0[1-9]|1[012])[- \/.](0[1-9]|[12][0-9]|3[01])[- \/.](19|20)\d\d)$')
      // ])),
      // Phone: new FormControl('', Validators.compose([
      //   Validators.required,
      //   Validators.pattern('^\\(?([0-9]{3})\\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$')
      // ])),
      AffiliateLink: [, Validators.required],
      IsAffiliate: []
      
    },[groupValidator]);


    this.managerMaintenanceForm.setValidators(this.comparisonValidator())
    this.managerMaintenanceForm.setValidators(this.AffilateValidator())
    this.myDatePickerOptions = {
      // other options...
      dateFormat: 'mm/dd/yyyy',
      firstDayOfWeek:"su",
      // disableSince : this.disableAfter,
     // disableDays: this.disableDays,
      //disableWeekends: true,
      disableUntil : { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() - 1},
      editableDateField : false,
      showClearDateBtn: false,
      selectorHeight: '100%',
      selectorWidth: '100%',
      openSelectorOnInputClick : true,
      openSelectorTopOfInput : false
  };
    

  }

  public comparisonValidator() : ValidatorFn{
    return (group: FormGroup): ValidationErrors => {
       const control1 = group.controls['StartDate'];
       const control2 = group.controls['EndDate'];
       
       if (control1.value.formatted != undefined     && control2.value.formatted != undefined && new Date(control1.value.formatted) > new Date(control2.value.formatted) )  {
          control2.setErrors({notEquivalent:true});
       } else {
        if(control2.status != "INVALID")
        {
          control2.setErrors(null);
        }
          
       }
       return;
 };
}


public AffilateValidator() : ValidatorFn{
  return (group: FormGroup): ValidationErrors => {
    
     const control1 = group.controls['IsAffiliate'];
     const control2 = group.controls['Affiliate'];
     if (control1.value && (control2.value == null || control2.value == "" ))  {
        control2.setErrors({required:true});
     } else {
      // if(control2.status != "INVALID")
      //{
        control2.setErrors(null);
      //}
        
     }
     return;
};
}

  account_validation_messages = {
   
    'PromoCode': [
      { type: 'required', message: 'The promo code field is required' },
      { type: 'PromoCodeExists', message: 'The promo code already exists.'}
    
    ],
    'PromoCodeDescription': [
      { type: 'required', message: 'The promo code description field is required' },
    ],
    'StartDate':[
      { type: 'required', message: 'The start date field is required' },
      { type: 'pattern', message: 'Please enter a valid date.' }
    ],
    'EndDate':[
      { type: 'required', message: 'The end date field is required' },
      { type: 'pattern', message: 'Please enter a valid date.' },
      {type:"notEquivalent" , message: 'End date should be greater then start date.'}
    ],
    'Affiliate':[
      { type: 'required', message: 'The affiliate field is required' },
      // { type: 'pattern', message: 'Please enter a valid phone number.' }
    ],
    'AffiliateLink': [
      { type: 'required', message: 'The affiliate link field is required' },
    ],
    'IsAffiliate': [
      //{ },
    ],
    }
    openModal(template: ElementRef<any>) {
      this.modalRef = this.modalService.show(
        template,
        Object.assign({}, { class: 'gray modal-small' },this.ngbModalOptions)
      );
    }

  ngOnInit() {


    $('[data-toggle="tooltip"]').tooltip({
      animated: 'fade',
      placement: 'bottom',
      trigger: 'click'
  });

    $('#PromoCode').keypress(function( e ) {
      if(e.which === 32 || e.which == 47 || e.which == 92) 
          return false;
    });

    this.residentialService
    .GetAllAffilations()
    .subscribe((res: any) => {

      this.AffiliateList = res;

      // this.AffiliateList.unshift( {
      //   AffiliateName: "Select",
      //   _id: "",
      //   })

    });
    
    
    this.pageheadername = "Create Promo code";
    this.route.params.subscribe(params => {
    
      this.PromoCodeId = params['id']

    });
   if(this.PromoCodeId != undefined && this.PromoCodeId != "")
   {
    this.pageheadername = "Edit Promo code";
    this.getPromocodeInfobyId();
   }
    
   $("#StartDate").mask("00/00/0000")
   $("#EndDate").mask("00/00/0000")
    
  }
  Status;
  getPromocodeInfobyId() {
    this.residentialService
      .GetPromoCodeById(this.PromoCodeId)
      .subscribe((response: any) => {
        // console.log(response);
        if(response.length != 0)
        {
          this.managerMaintenanceForm.setValue({
            PromoCode: response[0].PromoCode,
            PromoCodeDescription: response[0].PromoCodeDescription,
            StartDate: response[0].CompleteStartDate,
            EndDate: response[0].CompleteEndDate,
            Affiliate: !response[0].IsAffiliate ? null : response[0].Affiliate,
            AffiliateLink: response[0].AffiliateLink ? response[0].AffiliateLink : '',
            IsAffiliate: response[0].IsAffiliate
          });

          if(response[0].IsAffiliate == true)
          {
            this.ShowAffilateField = true;

          }
          this.Status = response[0].Status
        }




      });


  }

  ChangeAffilateCheck(event)
  {
    var IsAffiliate = event.target.checked;
    if(event.target.checked)
    {
      this.ShowAffilateField = true
     
    }else
    {
      this.ShowAffilateField = false
      this.managerMaintenanceForm.controls['Affiliate'].setValue(null);
    }
    this.Generatelink()
  }

  AddEditPromoCode(form){
    var UserID;
    if (!_.isEmpty(sessionStorage.getItem('userObj'))) {
      let result = JSON.parse(sessionStorage.getItem('userObj'));
      if (result.userObj._id) {
        UserID = result.userObj._id;
      } 
    }

    if (this.managerMaintenanceForm.valid) {
     
      var link = this.Generatelink()
      var PromoModel = {
        _id: this.PromoCodeId,
        PromoCode: form.PromoCode,
        PromoCodeDescription: form.PromoCodeDescription,
        StartDate: new Date(form.StartDate.jsdate).toISOString(),//form.StartDate.jsdate.toISOString(),
        EndDate: new Date(form.EndDate.jsdate).toISOString(),//form.EndDate.jsdate.toISOString(),
        CompleteStartDate: form.StartDate,
        CompleteEndDate: form.EndDate,
        Affiliate : !form.IsAffiliate ? null : form.Affiliate,
        Status: this.Status == '' || this.Status == undefined || this.Status == null ? 'Active' : this.Status,
        CreatedBy: UserID,
        AffiliateLink : link,
        SuspendedDate : '',
        IsAffiliate: form.IsAffiliate


      };

      this.residentialService
      .SavePromoCodeForm(PromoModel)
      .subscribe((response: any) => {
        this.msg ="Promocode has been created successfully";
        if(this.pageheadername.indexOf('Edit') > -1 )
        {
          this.msg ="Promocode has been updated successfully";
        }
        this.title = this.pageheadername;
        
        this.router.navigate([
          'hg-admin-promocode-addedit',
          response,
        ]);

        this.openModal(this.SuccessModel);

      });


    }else
    {
      this.managerMaintenanceForm.markAllAsTouched();
    }


  }
  
  uniquePromoValidator() : ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => { 
      if(control.value === "") {
        return  null;
      }
    //  setTimeout(function(){

        this.residentialService.CheckPromoExists(control.value,this.PromoCodeId)
        .subscribe((response: any) => {
           if (response) { 
              return {PromoCodeExists: true}
           } else {
            return {PromoCodeExists: true}
           }
        });
      //},1000)
   

   

    //return {PromoCodeExists: true}
    };
  }
  ChnagePromo(e)
  {
    var a = e.managerMaintenanceForm.get('PromoCode').value;
    if(a != '')
    {
      this.residentialService.CheckPromoExists(a,this.PromoCodeId)
      .subscribe((response: any) => {
  
        const control1 = this.managerMaintenanceForm.controls['PromoCode'];
  
         
          if (response) { 
            control1.setErrors({PromoCodeExists:true});
         } else {
          if(control1.status != "INVALID")
          {
            control1.setErrors(null);
          }
         }
  
         
      });
    }
   
  }

  Generatelink()
  {
    var p = this.managerMaintenanceForm.get('PromoCode').value;
    var a = this.managerMaintenanceForm.get('Affiliate').value;
   
    var obj_ = this.AffiliateList.filter(x => x._id == a);
    var a_  = "";
    if(obj_.length != 0)
    {
        a_  = obj_[0].AffiliateName;
    }
  

    var AffiliateLink_ = this.residentialService.GenerateLink(a_, p);
     this.managerMaintenanceForm.get('AffiliateLink').setValue(AffiliateLink_);
     return AffiliateLink_;
    //this.managerMaintenanceForm.setValue({AffiliateLink:AffiliateLink_});
  }




}
function dateRangeValidator(min: Date, max: Date): ValidatorFn {
  
  return control => {
    if (!control.value) return null;

    const dateValue = new Date(control.value);

    if (min && dateValue < min) {
      return { message: 'error message' };
    }

    if (max && dateValue > max) {
      return { message: 'error message' };
    }

    null;
  }

 
}
function groupValidator(group: AbstractControl): ValidationErrors | null {
  const fromCtrl = group.get('StartDate');
  const toCtrl = group.get('EndDate');

  return new Date(fromCtrl.value) > new Date(toCtrl.value) ? { message: 'error message' } : null;
}


export class UsernameValidator {
  static createValidator(userService: ResidentialService): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors> => {
      return userService
        .CheckPromoExists(control.value,0)
        .pipe(
          map((result: boolean) =>
            result ? { PromoCodeExists: true } : null
          )
        );
    };
  }

}
